function sanitizePhotoSelection(files = [], maxPhotos = 5) {
  const seen = new Set();
  const valid = [];

  for (const file of Array.from(files || [])) {
    if (!file || typeof file.name !== 'string') continue;

    const isImageByType = !!file.type && file.type.startsWith('image/');
    const isImageByName = /\.(png|jpe?g|gif|bmp|webp|heic|heif)$/i.test(file.name);
    if (!isImageByType && !isImageByName) continue;

    const key = `${file.name}-${file.size}-${file.lastModified || 0}`;
    if (seen.has(key)) continue;
    seen.add(key);
    valid.push(file);

    if (valid.length >= maxPhotos) break;
  }

  return valid;
}

function fileToDataUrl(file) {
  return new Promise((resolve) => {
    if (!file) {
      resolve(null);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(file);
  });
}

function dataUrlToFile(dataUrl, fileName, lastModified = Date.now(), mimeType = 'image/webp') {
  if (!dataUrl || typeof dataUrl !== 'string') return null;

  const byteString = atob(dataUrl.split(',')[1] || '');
  const bytes = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    bytes[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType || 'image/webp' });
  return new File([blob], fileName || 'photo.webp', {
    type: mimeType || 'image/webp',
    lastModified
  });
}

function serializePhotoDraft(files = [], maxPhotos = 5) {
  return Promise.all(
    sanitizePhotoSelection(files, maxPhotos).map(async (file) => {
      const dataUrl = await fileToDataUrl(file);
      if (!dataUrl) return null;

      return {
        name: file.name || `photo-${Date.now()}.webp`,
        type: file.type || 'image/webp',
        lastModified: file.lastModified || Date.now(),
        size: file.size || 0,
        dataUrl
      };
    })
  ).then(items => items.filter(Boolean));
}

function deserializePhotoDraft(rawDraft = [], maxPhotos = 5) {
  try {
    const draft = Array.isArray(rawDraft) ? rawDraft : JSON.parse(rawDraft || '[]');
    return draft
      .filter(Boolean)
      .filter(item => item && typeof item.dataUrl === 'string')
      .slice(0, maxPhotos)
      .map(item => dataUrlToFile(item.dataUrl, item.name, item.lastModified || Date.now(), item.type || 'image/webp'))
      .filter(Boolean);
  } catch (e) {
    return [];
  }
}

module.exports = {
  sanitizePhotoSelection,
  fileToDataUrl,
  dataUrlToFile,
  serializePhotoDraft,
  deserializePhotoDraft
};
